export const STORY_MENTION_REPLY_FETCH = 'STORY_MENTION_REPLY_FETCH'
export const STORY_MENTION_REPLY_UPDATE_ENABLED = 'STORY_MENTION_REPLY_UPDATE_ENABLED'
export const STORY_MENTION_REPLY_SET_FLOW = 'STORY_MENTION_REPLY_SET_FLOW'
export const STORY_MENTION_REPLY_REMOVE_FLOW = 'STORY_MENTION_REPLY_REMOVE_FLOW'
export const STORY_MENTION_REPLY_CHANGE_TYPE = 'STORY_MENTION_REPLY_CHANGE_TYPE'
export const STORY_MENTION_AUTO_LIKE = 'STORY_MENTION_AUTO_LIKE'
export const STORY_MENTION_DELAY = 'STORY_MENTION_DELAY'
